export const SHOW_MODAL_GHI_CHU_CHO_VAY = "SHOW_MODAL_GHI_CHU_CHO_VAY";
export const SHOW_MODAL_GHI_CHU_CHO_VAY_SUCCESS =
  "SHOW_MODAL_GHI_CHU_CHO_VAY_SUCCESS";
export const SHOW_MODAL_GHI_CHU_CHO_VAY_FAILURE =
  "SHOW_MODAL_GHI_CHU_CHO_VAY_FAILURE";

export const POST_GHI_CHU_CHO_VAY = "POST_GHI_CHU_CHO_VAY";
export const POST_GHI_CHU_CHO_VAY_SUCCESS = "POST_GHI_CHU_CHO_VAY_SUCCESS";
export const POST_GHI_CHU_CHO_VAY_FAILURE = "POST_GHI_CHU_CHO_VAY_FAILURE";

export const DELETE_GHI_CHU_CHO_VAY = "DELETE_GHI_CHU_CHO_VAY";
export const DELETE_GHI_CHU_CHO_VAY_SUCCESS = "DELETE_GHI_CHU_CHO_VAY_SUCCESS";
export const DELETE_GHI_CHU_CHO_VAY_FAILURE = "DELETE_GHI_CHU_CHO_VAY_FAILURE";
export const SET_LOAD_GHI_CHU_CHO_VAY = "SET_LOAD_GHI_CHU_CHO_VAY";
